import { dataAdjust } from 'dls-icons-data'
import { createIcon } from '../common'

const IconAdjust = /*#__PURE__*/createIcon(dataAdjust)
export default IconAdjust
